module.exports = __webpack_public_path__ + "static/media/edek1.14f45421.png";